import React, { useEffect } from 'react';
import { generalStore } from '../../store';

import FaqsList from '../../components/faqsList/FaqsList';

import { useTranslation } from 'react-i18next';

const FaqsView = () => {
    const { t, i18n } = useTranslation();
    const { setPageName } = generalStore();

    useEffect(() => {
        setPageName(t('faqs_title'));
    }, [i18n.language]);

    return (
        <div className="b-faqs-view">
            <FaqsList />
        </div>
    );
};

export default FaqsView;
